import CreateAreaContainer from "./CreateAreaContainer";
export default CreateAreaContainer;
